const subjects = {
  chinese: "國文",
  math: "數學",
  english: "英文",
  natural: "自然",
  society: "社會",
  chemistry: "化學",
  physical: "物理",
  biology: "生物",
  history: "歷史",
  geography: "地理",
  citizen: "公民",
  all: "全科",
};

export const getSubjectName = (key) => {
  return subjects[key];
};

export const getSubjectKey = (name) => {
  return Object.keys(subjects).find((key) => subjects[key] == name);
};
